export default __webpack_public_path__ + "static/media/F3D.90f82fff.mp3";